import React from "react";

import { useDispatch } from "react-redux";
import {getResetPasswordLink} from "../../../store/entities/Auth/Auth.actions";
import { useHistory } from "react-router-dom";
import URLS from "../../../config/navigation";
import ForgotPasswordForm from "../../../components/Auth/ForgotPasswordForm";
import HelmetComponent from "../../../components/Common/Helmet";
import TitleComponent from "../../../components/Auth/TitleContainer";
import Toast from "../../../components/Common/Toast";
import ToastMessage from "../../../components/Common/ToastMessage";
const ForgotPassword = (props) => {

  const dispatch = useDispatch();
  const history = useHistory();

  const callback = (response) => {
      if(response.status === 200){
          Toast(ToastMessage(1), "success")
      }else {
          Toast(ToastMessage(12), "error")
      }
  }

  const handleGetResetPasswordLink = (values, { setSubmitting }) => {
    dispatch(getResetPasswordLink({ ...values,  callback }));
  };

  return (
    <div className={"container"}>
      <HelmetComponent title="Reset your Password - TeachOn"/>
      <TitleComponent title={"Forgot password"} />
      <span className={"description BODY_MEDIUM"}>
        No problem! Enter your email and we’ll send you a link to reset your password
      </span>
      <div className={"formContainer"}>
        <ForgotPasswordForm handleSubmit={handleGetResetPasswordLink} />
        <span className={"haveAcc BODY_MEDIUM"}>
          <a
            className={'techOnlink BODY_MEDIUM'}
            onClick={() => history.push(URLS.AUTH.SIGNIN)}
          >
            Return to log In
          </a>
        </span>
      </div>
    </div>
  );
}

export default ForgotPassword;
